import { Action } from 'redux';

import { EnterPublishedConnectionSubspace } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IPublishedConnectionDetailInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';
import { PublishedConnectionSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

export interface EnterPublishedConnectionSubspaceReduxAction extends Action {
  readonly publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
  readonly subspaceName: PublishedConnectionSubspaceName;
  readonly requestContent: boolean;
}

export function enterPublishedConnectionSubspace(
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo,
  subspaceName: PublishedConnectionSubspaceName,
  requestContent: boolean,
): EnterPublishedConnectionSubspaceReduxAction {
  return {
    type: EnterPublishedConnectionSubspace,
    publishedConnectionDetailInfo,
    subspaceName,
    requestContent
  };
}

export const isEnterPublishedConnectionSubspaceAction = isActionFactory<EnterPublishedConnectionSubspaceReduxAction>(EnterPublishedConnectionSubspace);
